/** Desktop app updates: checking, downloading, installing. */
export default {
  checking: "Checking for updates…",
  upToDate: "You're up to date",
  checkFailed: "Update check failed",
  downloading: "Downloading {version}…",
  downloadingBody:
    "You can keep working. Denker will notify you when it is ready to restart.",
  downloadFailed: "Update download failed",
  downloadManually: "Download manually",
  readyTitle: "{version} is ready",
  readyBody: "A new version of Denker is ready to install.",
  criticalTitle: "Critical update: {version}",
  criticalBody: "This is a critical update. Restart Denker to install it now.",
  installNow: "Install now",
  tomorrow: "Tomorrow",
  installing: "Installing update…",
  installFailed: "Update failed",
  startFailed: "Could not start update",
  notReady: "Update is not ready yet",
  notReadyBody: "Check for updates again from the Help menu.",
  openDownloadFailed: "Couldn’t open the download",
  openAddressRetry: "Try again, or open this address in your browser: {url}",
  openAddress: "Open this address in your browser: {url}",
  localDevTitle: "Updates are disabled in Local Dev",
  localDevBody: "Use a Preview or Production build to check for updates.",
  updateTo: "Update to {version}",
  restartToInstall: "Restart to install.",
  installAndRestart: "Install {version} and restart",
} as const;
